import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Logout from "../views/Logout.vue";
import checkScope from "../middlewares/scope";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: async (to, from, next) => {
      if (await store.dispatch("auth/checkToken")) {
        next(from.path);
      } else {
        next();
      }
    }
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout
  },
  {
    path: "/",
    name: "",
    component: Home,
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("../views/Dashboard.vue")
      },
      {
        path: "products",
        name: "products",
        beforeEnter: checkScope("products.read"),
        component: () => import("../views/Products.vue")
      },
      {
        path: "categories",
        name: "categories",
        beforeEnter: checkScope("products.categories.read"),
        component: () => import("../views/Categories.vue")
      },
      {
        path: "brand",
        name: "brand",
        component: () => import("../views/Brand.vue")
      },
      {
        path: "product_prices",
        name: "product_prices",
        component: () => import("../views/ProductPrices.vue")
      },
    ]
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "*",
    component: Home,
    beforeEnter: (to, from, next) => {
      next("/");
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
